import { WhereClauseWithCondition } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isWhereClauseCondition } from "./isWhereClauseCondition";

/**
 * Type guard to check if a value is a WhereClauseWithCondition.
 *
 * @param obj - The value to check
 * @returns True if the value is a WhereClauseWithCondition
 */
export const isWhereClauseWithCondition = (obj: unknown): obj is WhereClauseWithCondition => {
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  const chkObj = obj as { condition?: unknown; compoundExpression?: unknown };

  // Must have a valid condition
  if (!isWhereClauseCondition(chkObj.condition)) return false;

  // Must not have compoundExpression property
  if (chkObj.compoundExpression !== undefined) return false;

  return true;
};
